import "./App.css";

import { Outlet, Routes, Route, BrowserRouter } from "react-router-dom";

import { WindowDimensionContextProvider } from "./hooks/useDimensions";

import Schedule from "./schedule/Schedule";
import About from "./about/About";
import Interviews from "./interviews/Interviews";
import Nav from "./nav/Nav";
import ScrollToTop from "./ScrollToTop";

// const router = createBrowserRouter([
//   {
//     path: "/",
//     element: <Schedule />,
//   },
//   {
//     path: "about",
//     element: <About />,
//   },
//   {
//     path: "interviews",
//     element: <Interviews />,
//   },
// ]);

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Schedule />} />
          <Route path="about" element={<About />} />
          <Route path="interviews" element={<Interviews />} />
        </Route>
        {/* <RouterProvider router={router} /> */}
      </Routes>
      <ScrollToTop />
    </BrowserRouter>
  );
}

function Layout() {
  return (
    <>
      <WindowDimensionContextProvider>
        <Nav />
        <Outlet />
      </WindowDimensionContextProvider>
    </>
  );
}

export default App;
